export default __webpack_public_path__ + "static/media/me3_Calculator.6b9f2d97.svg";